import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TopBannerComponent } from '../top-banner/top-banner.component';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [TopBannerComponent]
})
export class NotFoundComponent  {

  constructor(private router: Router) { }

  public logoClick(): void {
    this.router.navigate(['account/login']);
  }

  public goBack(): void {
    this.router.navigate(['profile']);
  }

}
